import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
import $R from 'plugins/tfs/platformConfigs/integrationMaps/routes';

export default function ProductBreadCrumb({
  selectedCategory,
  setSelectedCategory,
}) {
  const renderBreadCrumbItem = (selectedCategory) => {
    if (!selectedCategory) return null;
    const { url, parent, pk, label } = selectedCategory;
    return (
      <React.Fragment>
        {renderBreadCrumbItem(parent)}
        <Breadcrumb.Item key={pk}>
          <Link
            to={$R.PRODUCT_LIST.path + url}
            onClick={() => setSelectedCategory(pk)}
          >
            {label}
          </Link>
        </Breadcrumb.Item>
      </React.Fragment>
    );
  };

  return (
    <div className='product-breadcrumb'>
      <Breadcrumb separator='>'>
        {renderBreadCrumbItem(selectedCategory)}
      </Breadcrumb>
    </div>
  );
}

ProductBreadCrumb.propTypes = {
  selectedCategory: PropTypes.object,
  setSelectedCategory: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/product/list/ProductBreadCrumb.js